// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__2JJW-","DesktopOnly":"Toolbar__DesktopOnly__WADUd"};